var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5 608.5C180.567 804.363 107.299 615.168 114 660.5L1 263L614 239V532.5C614 532.5 552.433 412.637 366.5 608.5Z",
    fill: "#8ABFFC",
    stroke: "#18C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.5 458.5C68.5666 654.363 -4.70147 465.168 2 510.5L-111 113L502 89V382.5C502 382.5 440.433 262.637 254.5 458.5Z",
    fill: "#5CA8FF",
    stroke: "#18C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 301.5C66.5666 497.363 -6.70147 308.168 0 353.5L-113 -44L500 -68V225.5C500 225.5 438.433 105.637 252.5 301.5Z",
    fill: "#2982E9",
    stroke: "#18C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 220.5C128 419.5 1.5 259 1.5 242.5V4.5H502V132.5C502 132.5 384 21.5 256 220.5Z",
    fill: "#1F87FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5 114C26 245.5 -1 156 -1 156V1H501V79.5C501 79.5 451 -17.5 238.5 114Z",
    fill: "#0069E0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.75 131.833H163.25C130.757 131.833 104.417 158.174 104.417 190.667V337.75C104.417 370.243 130.757 396.583 163.25 396.583H339.75C372.243 396.583 398.583 370.243 398.583 337.75V190.667C398.583 158.174 372.243 131.833 339.75 131.833Z",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.667 102.417V161.25",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.333 102.417V161.25",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.417 220.083H398.583",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70b8b5b8c4adfc19781159530afd649f.svg";
export { ForwardRef as ReactComponent };